import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import _ from "lodash";

const FormUIItem = ({
    code,
    label,
    initValue,
    value,
    disabled,
    readOnly,
    required,
    type,
    unit,
    error,
    errorMessage,
    placeholder,
    handleUpdate }) => {
    return (<><div style={{ height: unit ? 4 : 0 }} />
        <FormControl
            style={{ marginTop: 16 }}
            fullWidth>
            <InputLabel required={required === true} htmlFor={`outlined-${code}`}>
                {label}
            </InputLabel>
            <OutlinedInput
                disabled={disabled}
                readOnly={readOnly}
                error={error}
                defaultValue={initValue}
                value={value}
                onChange={({ target }) => {
                    let { value } = target;
                    handleUpdate(code, value);
                }}
                startAdornment={
                    unit && <InputAdornment position="start">{unit}</InputAdornment>
                }
                type={type}
                required={required === true}
                id={`outlined-${code}`}
                label={label}
                placeholder={placeholder}
            />
            {
                error && <FormHelperText error id={`outlined-${code}-error`}>
                    {errorMessage}
                </FormHelperText>
            }
        </FormControl>
    </>);
}

export default FormUIItem;